import { Box, Button, alpha, useTheme } from "@mui/material";

interface PreviewErrorBubbleProps {
  onRetry?: () => void;
  maxWidth: number;
  borderRadius: number;
  fontSize: number;
  lineHeight: number;
}

export function PreviewErrorBubble({
  onRetry,
  maxWidth,
  borderRadius,
  fontSize,
  lineHeight,
}: PreviewErrorBubbleProps) {
  const theme = useTheme();
  return (
    <Box
      role="alert"
      sx={{
        maxWidth,
        padding: "8px 12px",
        borderRadius: `${borderRadius}px`,
        backgroundColor: alpha(theme.palette.warning.main, 0.14),
        border: `1px solid ${theme.palette.warning.main}`,
        color: theme.palette.warning.dark,
        fontSize,
        lineHeight: `${lineHeight}px`,
        fontWeight: theme.typography.fontWeightMedium,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      Preview error
      <Button
        size="small"
        color="warning"
        variant="contained"
        disabled={!onRetry}
        onClick={() => onRetry?.()}
        sx={{ alignSelf: "flex-start" }}
      >
        Retry
      </Button>
    </Box>
  );
}
